@let currentViewMode = viewMode();
@let currentUserData = userData();

@if (currentUserData) {
    <div
        class="flex flex-col justify-start"
        [class]="{
            'items-start': currentViewMode === 'breaking-left',
            'items-baseline': currentViewMode === 'inline',
            'md:flex-row': currentViewMode === 'inline',
            'text-lg': currentViewMode === 'inline',
        }">
        <span
            [class]="{
                'font-ci': currentViewMode === 'breaking-left',
                'h5': currentViewMode === 'breaking-left',
            }"
            class="p-0 m-0 text-primary dark:text-white">
            {{ currentUserData.name.fullTitle ?? '' }}
        </span>
        <span
            class="hidden mx-4 dark:text-primary-50"
            [class]="{ 'md:block': currentViewMode === 'inline' }">
            |
        </span>
        <span class="p-0 m-0 dark:text-primary-50 wrap-normal">
            @if (currentViewMode === 'breaking-left') {
                {{ idLabelTranslation() }}:
                {{ id() }}
            } @else {
                <span class="block min-[320px]:inline">{{ idLabelTranslation() }}:</span>
                <span class="block min-[320px]:inline">
                    {{ id() }}
                </span>
            }
        </span>
    </div>
}
